import React from 'react';

import { Modal, ModalProps } from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';
export const MarktechModal = (props: ModalProps): JSX.Element => (
  <Modal {...props} />
);
